import HashHistory from 'history/hash';

const history: any = HashHistory;

export default history;
